import React from "react";
import { useStudentsApi } from "./useStudentsApi";

export type DashboardConfigResponse =
  | {
      available: true;
      embedUrl: string;
      name?: string;
      from?: string;
      to?: string;
    }
  | {
      available: false;
    };

export type DashboardRangeResponse = {
  name?: string;
  from?: string;
  to?: string;
};

export const useAnalyticsDashboard = () => {
  const api = useStudentsApi();

  const fetchDashboardConfig =
    React.useCallback(async (): Promise<DashboardConfigResponse> => {
      const { data } = await api.get<DashboardConfigResponse>(
        "/api/analytics/dashboard"
      );
      return data;
    }, [api]);

  const fetchDashboardRange =
    React.useCallback(async (): Promise<DashboardRangeResponse> => {
      const { data } = await api.get<DashboardRangeResponse>(
        "/api/analytics/dashboard-range"
      );
      return data;
    }, [api]);

  const updateDashboardRange = React.useCallback(
    async (from: string, to: string): Promise<DashboardRangeResponse> => {
      const { data } = await api.post<DashboardRangeResponse>(
        "/api/analytics/dashboard-range",
        { from, to }
      );
      return data;
    },
    [api]
  );

  return {
    fetchDashboardConfig,
    fetchDashboardRange,
    updateDashboardRange,
  };
};
